<template>
  <div class="com">
    <div class="details">
      <div class="title">
        Purchaser Details
      </div>
      <div class="field" v-if="kit.woo_first_name !== null">
        {{ kit.woo_first_name }} {{ kit.woo_last_name }}
      </div>
      <div class="field" v-else>
        <span>No Data</span>
      </div>
      <div class="field" v-if="kit.collected_phone !== null">
        <span v-if="kit.collected_phone !== null">{{
          makePhone(kit.collected_phone)
        }}</span>
      </div>
      <div class="field" v-else>
        <span>No Data</span>
      </div>
      <div class="field email">
        <!--<span>{{user.email}}</span>-->
        <input
          type="text"
          v-model="emailInput"
          @click="checkInput"
          @input="sendProp"
          name="collected_email_admin"
          v-validate="'email'"
          placeholder="Email"
          :readonly="readonly"
        />
        <span class="validate-error" v-if="errors.has('collected_email_admin')">
          {{ errors.first("collected_email_admin") }}
        </span>
      </div>
      <div class="field email-edit" v-if="kit.state !== null">
        {{ kit.city }} {{ kit.state }}
      </div>
      <div class="field" v-else>
        No Data
      </div>
      <div class="field email-edit" v-if="kit.zip !== null">
        {{ kit.zip }}
      </div>
      <div class="field" v-else>
        No Data
      </div>
      <div class="field" v-if="kit.order_number !== null">
        Woo Order ID:
        <a
          :href="
            `${wordpress_order_page_url + kit.order_number + '&action=edit'}`
          "
          target="_blank"
          class="left-space"
          >{{ kit.order_number }}</a
        >
      </div>
      <div class="field" v-else>
        No Data
      </div>
      <button class="btn" @click="otherKits" v-show="!show">
        Other Kits of Customer
      </button>
    </div>
    <!--<div class="register" v-show="!show">-->
    <!--<span class="register-span">Registered:</span> November 25, 18-->
    <!--</div>-->
    <div class="title user" v-show="!show">
      User Details
    </div>
    <div class="field down email-edit" v-show="!show" v-if="user !== null">
      <span class="input-field" v-if="showEdit">
        <input
          type="text"
          class="input"
          v-validate="'required|max:50'"
          placeholder="First Name"
          name="userFirstName"
          maxlength="50"
          @change="changeVal('userFirstName', $event, first_name_count)"
          @focus="removeCaps('userFirstName', $event, 'focus')"
          v-on:keyup.delete="removeCaps('userFirstName', $event, 'delete')"
          v-model="userFirstName"
        />
        <span class="validate-error" v-if="errors.has('userFirstName')">
          {{ errors.first("userFirstName") }}
        </span>
        <input
          type="text"
          class="input"
          v-validate="'required|max:50'"
          placeholder="Last Name"
          name="userLastName"
          maxlength="50"
          @change="changeVal('userLastName', $event, first_name_count)"
          @focus="removeCaps('userLastName', $event, 'focus')"
          v-on:keyup.delete="removeCaps('userLastName', $event, 'delete')"
          v-model="userLastName"
        />
        <span class="validate-error" v-if="errors.has('userLastName')">
          {{ errors.first("userLastName") }}
        </span>
      </span>
      <span v-else>{{ user.first_name }} {{ user.last_name }}</span>
    </div>
    <div class="field down" v-show="!show" v-else>
      No Data
    </div>
    <div class="field down email-edit" v-show="!show" v-if="user !== null">
      <span class="input-field" v-if="showEdit">
        <input
          type="text"
          v-mask="'(###) ### - ####'"
          class="input"
          placeholder="Mobile Phone"
          name="phone"
          v-validate="
            'regex:^\\(([0-9]{3})\\)\\s([0-9]{3})\\s[-]\\s([0-9]{4})$|required|phone_exist'
          "
          v-model="userPhone"
        />
        <span class="validate-error" v-if="errors.has('phone')">
          {{ errors.first("phone") }}
        </span>
      </span>
      <span v-else>
        <p class="column-text" :class="{ phone_number: user.confirmed_phone }">
          {{ makePhone(user.phone) }}
        </p>
      </span>
    </div>
    <div class="field down" v-show="!show" v-else>
      No Data
    </div>
    <div class="field email-edit down" v-show="!show">
      <span class="input-field" v-if="user !== null && showEdit">
        <input
          type="text"
          class="input toLowerCase"
          placeholder="Email"
          name="email"
          v-validate="`required|email|email_exist_other_user:${user.id}`"
          v-model="userEmailInput"
        />
        <span class="validate-error errormes " v-if="errors.has('email')">
          <template v-if="errors.first('email') === 'email already user exist'">
            Email already in use.
          </template>
          <template v-else>
            {{ errors.first("email") }}
          </template>
        </span>
      </span>
      <span readonly v-else-if="user !== null">
        <p class="column-text" :class="{ email_address: user.confirmed_email }">
          {{ user.email }}
        </p>
      </span>
      <span readonly v-else>No Data</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "ModalInfo",
  props: ["show", "showEdit"],
  data() {
    return {
      user: null,
      kit: null,
      kit_id: "",
      emailInput: "",
      city: "",
      state: "",
      zip: "",
      userEmailInput: "",
      userLastName: "",
      userFirstName: "",
      userPhone: "",
      last_name_count: 0,
      first_name_count: 0,
      readonly: true,
      readonlyname: true,
      collected_last_name: "",
      collected_first_name: "",
      wordpress_order_page_url: process.env.VUE_APP_WORDPRESS_ORDER_PAGE_LINK
    };
  },
  computed: {
    ...mapGetters(["getTestKitInfo", "getAdminUserInfo"])
  },
  methods: {
    removeCaps(model, e, type) {
      if (type == "focus") {
        let val = 0;
        if (e.target.value.length > 0) {
          val = 1;
        }
        if (model == "first_name") {
          this.userFirstName = val;
        } else if (model == "last_name") {
          this.userLastName = val;
        }
      } else if (e.target.value.length == 0) {
        if (model == "first_name" && this.userFirstName == 0) {
          this.userFirstName = this.userFirstName + 1;
        } else if (model == "last_name" && this.userLastName == 0) {
          this.userLastName = this.userLastName + 1;
        }
      }
    },
    changeVal(model, e, count) {
      if (count == 0 && e.target.value.length > 0) {
        e.target.value = this.capitalizeVal(e.target.value);
        e.target.style.textTransform = "none";
      }
      this[model] = e.target.value;
    },
    capitalizeVal(input) {
      return input
        ? input.replace(/^\w{1,}|\w{4,}/g, function(word) {
            return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
          })
        : input;
    },
    sendProp() {
      this.$emit("sendProp", {
        firstName: this.collected_first_name,
        lastName: this.collected_last_name,
        email: this.emailInput
      });
    },
    checkStatus() {
      if (this.kit.status === "shipped") {
        this.readonlyname = false;
      }
    },
    checkInput() {
      if (this.kit.status === "shipped") {
        this.readonly = false;
      }
    },
    otherKits() {
      this.$emit("otherKits", true);
      this.show = false;
    },
    saveSubmit() {
      let data = {
        firstName: this.collected_first_name,
        lastName: this.collected_last_name,
        email: this.emailInput,
        testkit: {
          kit_id: this.kit_id,
          city: this.city,
          state: this.state,
          zip: this.zip,
          user: {
            email: this.userEmailInput.toLocaleLowerCase(),
            last_name: this.userLastName,
            first_name: this.userFirstName,
            phone: `1${this.userPhone.replace(/[\s-()+]/g, "")}`
          }
        }
      };
      this.$emit("editData", data);
      //this.saveUserSubmited(data);
    },
    makePhone(phone) {
      // Check if phone is null or undefined
      if (phone === null || phone === undefined) {
        return "No Data";
      }

      // Remove any non-digit characters from the input
      const cleanPhone = phone.replace(/\D/g, "");

      // Check if the cleaned phone number is exactly 10 digits
      if (cleanPhone.length === 11 || cleanPhone.length === 10) {
        const phoneArr = cleanPhone.split("");
        let convertedPhone = null;
        if (cleanPhone.length === 11) {
          convertedPhone = `(${phoneArr[1]}${phoneArr[2]}${phoneArr[3]}) ${
            phoneArr[4]
          }${phoneArr[5]}${phoneArr[6]}-${phoneArr[7]}${phoneArr[8]}${
            phoneArr[9]
          }${phoneArr[10]}`;
        } else if (cleanPhone.length === 10) {
          convertedPhone = `(${phoneArr[0]}${phoneArr[1]}${phoneArr[2]}) ${
            phoneArr[3]
          }${phoneArr[4]}${phoneArr[5]}-${phoneArr[6]}${phoneArr[7]}${
            phoneArr[8]
          }${phoneArr[9]}`;
        }
        return convertedPhone;
      } else {
        return "No Data";
      }
    }
  },
  watch: {
    errors: {
      deep: true,
      handler(errorsNew) {
        this.$emit("emailError", errorsNew);
      }
    },
    city() {
      this.saveSubmit();
    },
    state() {
      this.saveSubmit();
    },
    zip() {
      this.saveSubmit();
    },
    userEmailInput() {
      this.saveSubmit();
    },
    userFirstName() {
      this.saveSubmit();
    },
    userLastName() {
      this.saveSubmit();
    },
    userPhone() {
      this.saveSubmit();
    },
    getTestKitInfo(obj) {
      this.kit = obj;
    },
    getAdminUserInfo(obj) {
      if (obj !== null) {
        this.user = obj;
      }
    }
  },
  inject: ["$validator"],
  created() {
    if (this.$store.getters.getAdminUserInfo !== null) {
      this.user = this.$store.getters.getAdminUserInfo;
      if (this.user.email !== null) {
        this.userEmailInput = this.user.email;
      }
      if (this.user.last_name !== null) {
        this.userLastName = this.user.last_name;
      }
      if (this.user.first_name !== null) {
        this.userFirstName = this.user.first_name;
      }
      if (this.user.phone !== null) {
        this.userPhone = this.makePhone(this.user.phone);
      }
    }
    this.kit = this.$store.getters.getTestKitInfo;

    if (this.kit.id !== null) {
      this.kit_id = this.kit.id;
    }
    if (this.kit.city !== null) {
      this.city = this.kit.city;
    }
    if (this.kit.state !== null) {
      this.state = this.kit.state;
    }
    if (this.kit.zip !== null) {
      this.zip = this.kit.zip;
    }
    if (this.kit.collected_email !== null) {
      this.emailInput = this.kit.collected_email;
    }
    if (this.kit.collected_first_name !== null) {
      this.collected_last_name = this.kit.collected_last_name;
      this.collected_first_name = this.kit.collected_first_name;
    }
  }
};
</script>

<style scoped>
.com {
  height: 100%;
  padding: 15px;
  max-width: 340px;
  width: 100%;
  background-color: #03409a;
}
.details {
  background-color: #005eb8;
  border-radius: 10px;
  padding: 15px 15px 20px 15px;
}
.title {
  padding: 20px 0 20px 0;
  text-align: center;
  color: #fff;
  font-size: 16px;
  font-family: TTNormsMedium, sans-serif;
}
.title.user {
  padding: 20px 0 20px 0;
}
.register {
  padding: 30px 0 20px 0;
  text-align: center;
  color: #fff;
  font-size: 14px;
  font-family: TTNormsMedium, sans-serif;
}
.register-span {
  font-family: TTNormsLight, sans-serif;
}
.name {
  color: #fff;
  font-size: 14px;
  font-family: TTNormsMedium, sans-serif;
  padding: 0 5px 30px 5px;
  text-align: center;
  display: flex;
  justify-content: center;
  overflow: hidden;
}
.field {
  width: 100%;
  height: 40px;
  background-color: #053c91;
  margin: 0 0 20px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 14px;
  position: relative;
  font-family: TTNormsLight, sans-serif;
}

.buttons {
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 14px;
  position: relative;
  font-family: TTNormsLight, sans-serif;
}
.buttons input {
  height: 40px;
  width: 100%;
  background-color: transparent;
  outline: none;
  border: 1px solid transparent;
  color: #000000;
  text-align: center;
  cursor: default;
  padding: 0 10px;
  font-size: 14px;
  font-family: TTNormsLight, sans-serif;
}
.input-field {
  width: 100%;
  background-color: #a8a8a8b6;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #000000;
  font-size: 14px;
  position: relative;
  font-family: TTNormsLight, sans-serif;
}
.field.down {
  background-color: #073884;
  width: 280px;
  margin: 0 auto 20px auto;
}
.field a {
  color: #fff;
}
.btn {
  color: #fff;
  border: 1px solid #053c91;
  box-shadow: 0px 0px 20px 0px rgba(5, 60, 145, 1);
  border-radius: 30px;
  width: 245px;
  margin: 25px auto 0 auto;
  outline: none;
  cursor: pointer;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #005eb8;
}

.btns {
  color: #fff;
  border: 1px solid #053c91;
  box-shadow: 0px 0px 20px 0px rgba(5, 60, 145, 1);
  border-radius: 30px;
  margin: 25px auto 0 auto;
  outline: none;
  cursor: pointer;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #005eb8;
}
.edit {
  width: 100px;
}
.customer {
  width: 170px;
}
.field.email input {
  height: 40px;
  width: 100%;
  background-color: transparent;
  outline: none;
  border: 1px solid transparent;
  color: #ffffff;
  text-align: center;
  cursor: default;
  padding: 0 10px;
  font-size: 14px;
  font-family: TTNormsMedium, sans-serif;
}
.field.email-edit input {
  height: 40px;
  width: 100%;
  background-color: transparent;
  outline: none;
  border: 1px solid transparent;
  color: #080808;
  text-align: center;
  cursor: default;
  padding: 0 10px;
  font-size: 14px;
  font-family: TTNormsMedium, sans-serif;
}

.nameInput {
  background-color: transparent;
  color: #fff;
  font-size: 14px;
  outline: none;
  border: 1px solid transparent;
  font-family: TTNormsMedium, sans-serif;
  padding: 5px;
  max-width: 50%;
  width: 100%;
  transition: border 0.3s linear;
}
.nameInput.right {
  text-align: right;
  padding-right: 1px;
}
.nameInput.left {
  text-align: left;
  padding-left: 1px;
}
.nameInput.input {
  border: 1px solid #e4e4e4;
}
.input {
  border-radius: 10px;
  padding: 15px 20px;
  color: #373737;
  width: 285px;
  font-size: 16px;
  border: 1px solid #cccccc;
  text-align: center;
  outline: none;
  margin: 0;
  font-family: TTNormsMedium, sans-serif;
}
@media (max-height: 790px) {
  .com {
    overflow-y: scroll;
  }
  .com::-webkit-scrollbar {
    width: 0px; /* remove scrollbar space */
    background: transparent; /* optional: just make scrollbar invisible */
  }
  /* optional: show position indicator in red */
  .com::-webkit-scrollbar-thumb {
    background: #ff0000;
  }
}

@media print {
  .com {
    display: none;
  }
}
.left-space {
  margin-left: 5px;
}
</style>
<style scoped lang="scss">
.email_address,
.phone_number {
  position: relative;
  &:after {
    content: "";
    position: absolute;
    display: block;
    top: -4px;
    right: -30px;
    width: 24px;
    height: 24px;
    background: url("../../images/home/verfication-border.png") center no-repeat;
    background-size: 15px;
    cursor: pointer;
  }
  &:hover::before {
    content: "Verified";
    position: absolute;
    display: block;
    top: 2px;
    right: -75px;
    color: #ffffff;
    font-size: 11px;
    font-family: TTNormsMedium, sans-serif;
  }
}

.email_address_input,
.phone_number_input {
  position: relative;
  &:after {
    content: "";
    display: block;
    width: 24px;
    height: 24px;
    background: url("../../images/home/verfication-border.png") center no-repeat;
    background-size: 15px;
    cursor: pointer;
  }
  &:hover::before {
    content: "Verified";
    display: block;
    top: 2px;
    color: #ffffff;
    font-size: 11px;
    font-family: TTNormsMedium, sans-serif;
  }
}
.errormes {
  padding-top: 10px;
}
</style>
